export enum ValidationCode {
    Required = 10000,
    Invalid = 10001,
    InvalidFormat = 10002,
    MinLength = 10003,
    MaxLength = 10004,
    MinDate = 10005,
    MaxDate = 10006,
    MaxCount = 10007,
    MaxSize = 10008,
    Duplicated = 10009,
    InList = 10010,
    MinItems = 10011,
    MaxItems = 10012,
    InvalidPattern = 10013,
    Minimum = 10014,
    Maximum = 10015,
}
